<li on:keydown={handleMenuNavigation} class="mh-premium" on:mouseleave|stopPropagation={handleMouseLeave}>
  <button linkButton bind:this={button} on:mouseenter|stopPropagation={()=> (open = true) } 
    class={colorClassNames.primary}
    aria-expanded={open}
    aria-controls="premiumMenu"
    >
    <div class="mh-premium-title">
      <span>{text}</span>
    </div>
  </button>

  <div id="premiumMenu" class="mh-dropdown-menu" class:mh-open={open}>
    <PremiumDropdownMenu bind:this={menu} {items} />
  </div>
</li>

  <style lang="less">
    @import (reference) '../../../less/variables';

    li {
      display: flex;
      position: relative;

      /*
     * The additional styles below
     * override encore-web global
     * styles
     */
      font-size: @masthead-font-size-medium;
      line-height: inherit;
      letter-spacing: 0;
    }

    button {
      display: flex;
      align-items: center;
      background-color: transparent;
      border: none;
      padding: 28px 17px;
      text-decoration: none;
      font: inherit;
      font-weight: @masthead-font-weight-bold;
      outline: none;
      cursor: pointer;
    }

    button:hover,
    button:focus {
      color: currentColor;
    }

    .mh-premium-title {
      display: inline-block;
      margin: auto 0;
    }

    span {
      display: inline-block;
      margin: auto 0 auto 10px;
    }

    .mh-dropdown-menu {
      display: none;
    }

    .mh-dropdown-menu.mh-open {
      display: block;
      position: absolute;
      top: 100%;
    }

    @media (max-width: @breakpoint-tablet - 1) {
      button {
        display: none;
      }

      div.mh-dropdown-menu,
      div.mh-dropdown-menu.mh-open {
        display: block;
      }
    }
  </style>

  <script>
    import PremiumDropdownMenu from './PremiumDropdownMenu.html';
    import breakpoints from '../../../constants/breakpoints.json';

    export let text;
    export let items;
    export let colorClassNames;

    let button;
    let menu;
    let open = false;

    const handleMouseLeave = () => {
      setTimeout(() => {
        open = false
      }, 300)
    }

    const handleMenuNavigation = event => {
      if (window.innerWidth < breakpoints['breakpoint-tablet']) {
        return;
      }

      const HANDLED_KEYS = ['Escape', 'ArrowDown', 'ArrowUp'];

      if (HANDLED_KEYS.includes(event.key)) {
        event.stopPropagation();
        event.preventDefault();
      }

      if (event.key === 'Escape') {
        open = false;
        button.focus();
      } else if (event.key === 'ArrowDown') {
        open = true;
        menu.selectNext();
      } else if (event.key === 'ArrowUp') {
        open = true;
        menu.selectPrevious();
      }
    };
  </script>